import React from 'react'
import { Link } from 'react-router-dom'
import { BadgeCheck, Compass, Repeat2 } from 'lucide-react'
import MarketingSiteLayout from '../../marketing/MarketingSiteLayout'
import { LANDING_PATH, PUBLIC_INQUIRY_PATH } from '../../marketing/marketingNav'

const values = [
  { title: '현장 중심', body: '설계사·매니저·조직이 실제로 쓰는 흐름을 먼저 봅니다.', Icon: Compass },
  { title: '투명한 협업', body: '의뢰·배정·소통이 한곳에 남아 업무 상태를 분명하게 만듭니다.', Icon: BadgeCheck },
  { title: '꾸준한 개선', body: '피드백을 바탕으로 분석, 의뢰, 모객 기능을 계속 다듬습니다.', Icon: Repeat2 },
]

export default function AboutPage() {
  return (
    <MarketingSiteLayout>
      <div className="relative overflow-hidden border-b border-slate-200 bg-white">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(15,23,42,0.045)_1px,transparent_1px),linear-gradient(to_bottom,rgba(15,23,42,0.045)_1px,transparent_1px)] bg-[size:44px_44px]" />
        <div className="relative mx-auto grid max-w-6xl gap-10 px-4 py-16 md:grid-cols-[1fr_0.85fr] md:items-center md:py-24">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.28em] text-brand-sky">About</p>
            <h1 className="mt-4 text-4xl font-black leading-tight tracking-tight text-slate-900 sm:text-5xl md:text-6xl">
              <span className="text-brand-navy">설계EZ</span>
              <br />
              보험 설계의 표준을 재정의하다.
            </h1>
            <p className="mt-8 max-w-2xl text-lg leading-relaxed text-slate-600">
              설계EZ는 보험 설계 의뢰, 분석, 고객 접점이 흩어지지 않도록 개인 설계사부터 GA·원수사 팀까지
              함께 사용할 수 있는 업무 플랫폼을 만들고 있습니다.
            </p>
            <div className="mt-10 flex flex-wrap gap-3">
              <Link
                to={PUBLIC_INQUIRY_PATH}
                className="inline-flex min-h-[46px] items-center justify-center rounded-lg bg-brand-navy px-6 text-sm font-bold text-white shadow-md transition hover:bg-sky-700"
              >
                도입 문의하기
              </Link>
              <Link
                to={LANDING_PATH}
                className="inline-flex min-h-[46px] items-center justify-center rounded-lg border border-slate-300 bg-white px-6 text-sm font-semibold text-slate-800 transition hover:border-sky-200 hover:bg-sky-50"
              >
                설계EZ 소개
              </Link>
            </div>
          </div>

          <div className="rounded-lg border border-slate-200 bg-white/90 p-5 shadow-xl shadow-slate-200/80 backdrop-blur">
            <div className="rounded-lg bg-slate-950 p-5 text-white">
              <div className="text-xs font-bold tracking-[0.2em] text-sky-200">OPERATING PRINCIPLE</div>
              <div className="mt-6 space-y-4">
                {['흩어진 요청을 한 흐름으로 모으기', '담당자와 상태를 분명하게 남기기', '현장 피드백으로 기능을 개선하기'].map((item) => (
                  <div key={item} className="flex items-center gap-3 rounded-lg bg-white/10 px-4 py-3">
                    <span className="h-2 w-2 rounded-full bg-brand-mint" />
                    <span className="text-sm font-semibold">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-6xl px-4 py-16 md:py-20">
        <p className="text-xs font-bold uppercase tracking-[0.24em] text-brand-sky">Values</p>
        <h2 className="mt-3 text-2xl font-black text-slate-900 sm:text-3xl">서비스를 만들 때 지키는 기준</h2>
        <div className="mt-10 grid gap-5 md:grid-cols-3">
          {values.map(({ title, body, Icon }) => (
            <article key={title} className="rounded-lg border border-slate-200 bg-white p-7 shadow-sm">
              <Icon className="h-6 w-6 text-brand-sky" aria-hidden="true" />
              <h3 className="mt-5 text-lg font-black text-slate-900">{title}</h3>
              <p className="mt-3 text-sm leading-7 text-slate-600">{body}</p>
            </article>
          ))}
        </div>
      </div>

      <div className="border-t border-slate-200 bg-white">
        <div className="mx-auto max-w-6xl px-4 py-16 md:py-20">
          <h2 className="text-2xl font-black text-slate-900 sm:text-3xl">사업자 정보</h2>
          <dl className="mt-8 grid gap-4 text-sm text-slate-700 sm:grid-cols-2">
            <div className="rounded-lg bg-slate-50 p-4">
              <dt className="font-semibold text-slate-900">상호</dt>
              <dd className="mt-1">설계 EZ (가라멜 스튜디오)</dd>
            </div>
            <div className="rounded-lg bg-slate-50 p-4">
              <dt className="font-semibold text-slate-900">대표</dt>
              <dd className="mt-1">가승호</dd>
            </div>
            <div className="rounded-lg bg-slate-50 p-4">
              <dt className="font-semibold text-slate-900">개인정보 보호책임자</dt>
              <dd className="mt-1">가승호(대표)</dd>
            </div>
            <div className="rounded-lg bg-slate-50 p-4">
              <dt className="font-semibold text-slate-900">사업자등록번호</dt>
              <dd className="mt-1">555-46-01166</dd>
            </div>
            <div className="rounded-lg bg-slate-50 p-4">
              <dt className="font-semibold text-slate-900">통신판매업신고번호</dt>
              <dd className="mt-1">2026-부천원미-1316</dd>
            </div>
            <div className="rounded-lg bg-slate-50 p-4">
              <dt className="font-semibold text-slate-900">주소</dt>
              <dd className="mt-1">경기도 부천시 원미구 수도로 206번길 66-8, 3동 202호</dd>
            </div>
            <div className="rounded-lg bg-slate-50 p-4">
              <dt className="font-semibold text-slate-900">연락처</dt>
              <dd className="mt-1">전화 0505-007-8200</dd>
              <dd>이메일 support@sgez.co.kr</dd>
            </div>
          </dl>
          <p className="mt-8 text-xs text-slate-500">해당 정보는 푸터와 동일하며, 변경 시 공개 페이지에 함께 반영됩니다.</p>
        </div>
      </div>
    </MarketingSiteLayout>
  )
}
